module.exports = __webpack_public_path__ + "static/media/githubStatic.917020a7.svg";